function camelToSpaceCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}

function styleObjectToString(style: Record<string, any>): string {
  return Object.entries(style)
    .map(([key, value]) => {
      const normalizedKey = camelToSpaceCase(key);

      if (typeof value === 'object') {
        return `${normalizedKey}{${styleObjectToString(value)};}`;
      }

      if (normalizedKey === 'font-family') {
        return `${normalizedKey}:'${value}'`;
      }

      return `${normalizedKey}:${value}`;
    })
    .join(';');
}

const globalStyleString = (globalScopeCSS?: Record<string, any>[]) => {
  if (!globalScopeCSS?.length) return;

  const globalStyles = globalScopeCSS?.map((styleObject) => {
    return styleObjectToString(styleObject);
  });

  return globalStyles.join('');
};

export default globalStyleString;
